import React from "react";
import ProjectImg1 from "../assets/Aprameya_Site.png";
import ProjectImg2 from "../assets/CSIT_ER.png";
import ProjectImg3 from "../assets/Odin_Mail.png";

const Projects = () => {
  const projects = [
    {
      index: 1,
      thumbnail: ProjectImg1,
      title: "Aprameya – Autonomous Systems Club",
      logoalt: "Aprameya Logo",
      CodeHref: () =>
        window.open("https://github.com/isuryaprakashh/Aprameya", "_blank"),
      DemoHref: () =>
        window.open("https://aprameya.kluniversity.me", "_blank"),
    },
    {
      index: 2,
      thumbnail: ProjectImg2,
      title: "CSIT Exit Requirements",
      logoalt: "CSIT Exit Requirements Logo",
      CodeHref: () =>
        window.open(
          "https://github.com/Akhilpanvi/KLEF-Y22-CSIT_Student_Exit_Requirements",
          "_blank"
        ),
      DemoHref: () =>
        window.open("http://csit-y22.kluniversity.me", "_blank"),
    },
    {
      index: 3,
      thumbnail: ProjectImg3,
      title: "Odin Mail",
      logoalt: "Odin Mail Logo",
      CodeHref: () =>
        window.open("https://github.com/Akhilpanvi/Odinsite", "_blank"),
      DemoHref: () =>
        window.open("http://odinmail.dev", "_blank"),
    },
  ];
  return (
    <div
      name="Projects"
      className="mt-4 py-4 mx-2  md:max-w-screen-xl md:mx-auto rounded-lg md:w-full border-[#fdf0d5] bg-gradient-to-b from-[#aba79d] to-[#344e41]"
    >
      <h4 className="text-3xl sm:text-5xl font-bold text-[#fdf0d5] hover:text-my-bg-color duration-200 m-4 md:ml-14 my-2">
        Projects
      </h4>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 px-4 md:px-8">
        {projects.map((project) => (
          <div
            key={project.index}
            className="group shadow-md shadow-gray-600 rounded-lg md:mx-4 md:mt-4 bg-gradient-to-b from-[#aba79d] to-[#344e41] px-3 py-2 cursor-pointer"
          >
            <img
              className="rounded-md group-hover:md:scale-105 duration-200"
              src={project.thumbnail}
              alt={project.logoalt}
            />
            <h3 className="mt-2 text-center text-my-bg-color text-1xl font-semibold">
              {project.title}
            </h3>
            <div className="flex flex-row justify-around mt-2">
              <button
                onClick={project.DemoHref}
                className="group w-fit px-6 py-3 my-2 flex items-center rounded-full bg-my-bg-color cursor-pointer shadow-md hover:bg-[#faedcd] duration-200"
              >
                Demo
              </button>
              <button
                onClick={project.CodeHref}
                className="group w-fit px-6 py-3 my-2 flex items-center rounded-full bg-my-bg-color cursor-pointer shadow-md hover:bg-[#faedcd] duration-200"
              >
                Code
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
